import { useEffect } from "react";

/**
 * Detects if a click is inside or outside a given div,
 * based on actual cursor position (x,y vs bounding box).
 */
export default function useDetectDivClick({ ref, insideDivCallback, outsideDivCallback }) {
    useEffect(() => {
        function handleClick(event) {
            if (!ref.current) return;

            const rect = ref.current.getBoundingClientRect();
            const x = event.clientX;
            const y = event.clientY;

            const isInside = x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;

            if (isInside) {
                insideDivCallback?.();
            } else {
                outsideDivCallback?.();
            }
        }

        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, [ref, insideDivCallback, outsideDivCallback]);
}
